import { dataArrowCurveUpRightSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconArrowCurveUpRightSolid = /*#__PURE__*/createIcon(dataArrowCurveUpRightSolid)
export default IconArrowCurveUpRightSolid
